import "./base/";
import "./cart/cart";
import "./collections/handleCollectionPagination";
import "./collections/mobileViewToggle";
import "./counters/quantityCounter";
import "./counters/animatedCounter";
// import "./currency/handleCurrency";
// import "./currency/handleMobileCurrency";
import "./currency/basic-currency";
import "./dropdown/closeDropdownOnClickOutside";
import "./dropdown/handleDropdown";
import "./editorialHub/handleEditorialHub";
import "./filter/handleFilter";
import "./megamenu/handleMegamenu";
import "./megamenu/handleMobileMegamenu";
import "./modal/closeModal";
import "./modal/closeQuickshopModal";
import "./modal/handleModal";
import "./modal/handleQuickshopModal";
import "./modules/accordions";
import "./modules/back-in-stock";
import "./modules/blind-quote-form";
import "./modules/custom-scrollbar";
import "./modules/instafeed-custom";
import "./modules/select-with-selectric";
import "./modules/toggle-buttons";
import "./modules/trade-account-form";
import "./modules/yotpo-reviews-custom";
import "./modules/custom-wishlist-page";
import "./modules/cart-addon";
import "./modules/observe-cart-drawer";
import "./modules/gift-instructions";
import "./modules/you-may-also-like";
import "./modules/handleSupportBanner";
import "./modules/handleCollectionScroll";
import "./modules/handleBadge";
import "./modules/handleRecommendedProducts";
import "./navigation/closeMobileNav";
import "./navigation/handleMobileNav";
import "./navigation/handleTabNav";
import "./navigation/reviewTabNav";
import "./newsletter/handleNewsletterPopup";
import "./product/ajax-actions";
import "./product/change-options";
import "./product/change-options-additional";
import "./product/quantity";
import "./product/recommended-products";
import "./product/sticky-cta";
import "./product/wallpaper-calculator-actions";
import "./search/handleSearch";
import "./search/searchResultPagination";
import "./sliders/handleSlider";
import "./sliders/product-slider";
import "./sliders/reviewSlider";
import "./sliders/relatedProductsSlider";
import "./utils/clicks";

const $win = $(window);
const $doc = $(document);
